/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Handle_Roles_By_BuildingInputs */



/**
* | output |
* | --- |
* | "Manage roles by building" |
*
* @param {Handle_Roles_By_BuildingInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const handle_roles_by_building = /** @type {((inputs?: Handle_Roles_By_BuildingInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Handle_Roles_By_BuildingInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Manage roles by building")
	return /** @type {LocalizedString} */ ("Gérer ses rôles par bâtiment")
});